import { FacilityClassification } from '@umss/shared/data-access';

export interface FacilitySearchDto {
  // Herda de PagedRequestDto
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | null;
  sortDescending?: boolean;

  // Filtros específicos de Facility
  classification?: FacilityClassification | null;
  isActive?: boolean | null; // Filter by active status. Defaults to true (only active facilities). Set to false for inactive only, or null for all facilities
  facilityTypeId?: number | null;
  stateCode?: string | null;
  latitude?: number | null; // decimal
  longitude?: number | null; // decimal
  radiusMiles?: number | null; // double
  corporateId?: string | null;
}
